<script>
import resources from './resources'

export default {
  name: 'my-address',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xl-4.col-lg-6.col-md-6.col-sm-12
    .card
      .header
        h2
          strong Morador - {{ living.people_name }}
        ul.header-dropdown
          li.dropdown(:class="{'show': actions}")
            a.dropdown-toggle(
              href='javascript:void(0);',
               data-toggle='dropdown',
               role='button',
               aria-haspopup='true',
               aria-expanded='false'
               @click.prevent="viewActions(actions)"
            )
              i.zmdi.zmdi-more
            ul.dropdown-menu.dropdown-menu-righ(
              x-placement='bottom-end',
              style='position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;'
              :class="{'show': actions}"
            )
              li
                router-link.cursor-pointer(:to="{name: 'tenant.livings.edit', params: {id: living.id, tower_id: living.tower_id, unit_id: living.unit_id}}") Editar
              li
                 a(href='javascript:void(0);', @click.prevent="$emit('on-delete', living)") Excluir
      .body
        .row
          .col-12
            h6.m-b-15
              span.badge.badge-default.float-right Situação -&nbsp;
                i.zmdi.zmdi-circle.offline(v-if="living.status === 'false'")
                i.zmdi.zmdi-circle.online(v-if="living.status === 'true'")
        .row
          .col-5
            small
              strong UND:

          .col-7
            small
              strong TORRE:
        .row
          .col-5
            | {{ living.unit.number}}
          .col-7
            small
              | {{ living.tower.name}}
        .row
          .col-5
            small
              strong Morador:

          .col-7
            small
              strong FONE:
        .row
          .col-5
            img(
              src='/static/images/xs/avatar1.jpg',
              title="rental.tenant.name",
              alt='avatat'
            )
          .col-7
            small {{ maskPhone(living.phone) }}
            br
            small {{ living.people_name }}

</template>
<style scoped>
  .online {
    color: #86BB71;
  }
  .offline {
    color: #E38968;
  }
  .online, .offline, .me {
      margin-right: 3px;
      font-size: 10px;
  }
  .material-icons {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 12px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/tenant/livings/index/components/item.vue